import { Component, Input } from '@angular/core';
import { App } from 'ionic-angular';
import { ToastDirective } from '../../shared/directives/toast/toast';

@Component({
  selector: 'ion-row[core-action-nav-buttons]',
  templateUrl: './action-nav-buttons.component.html'
})
export class ActionNavButtonsComponent {
  @Input() context: any;
  @Input() buttons: Array<any>;

  win = window;

  constructor(
    public app: App,
    public toast: ToastDirective
  ) {

  }

  onClickCallback(action) {
    if (action) {
      this.context[action]();
    }
  }

  openHelpMessage(message) {
    if (message) {
      this.toast.createAdv({ message: message, type: 'success' });
    }
  }

}



// WEBPACK FOOTER //
// ./src/core/action-nav-buttons/action-nav-buttons.component.ts